export default {
    'external': [
        {
            title: 'Welcome',
            component: 'welcome',
            subSteps: [],
        },
        {
            title: 'Activities',
            component: 'activities',
            subSteps: [
                {
                    title: 'Activities',
                    component: 'available-activity',
                },
                {
                    title: 'Activities',
                    component: 'subscribed-activity',
                }
            ],
        }
    ],
    'internal': [
        {
            title: 'Welcome',
            component: 'Activation',
            subSteps: [],
        },
        {
            title: 'Activities',
            component: 'activities',
            subSteps: [
                {
                    title: 'Activities',
                    component: 'available-activity',
                },
                {
                    title: 'Activities',
                    component: 'subscribed-activity',
                }
            ],
        }
    ]
}
